<div id="crop-monitoring">
  <div class="row" [class.d-none]="mode === 'seeAllNotes'">
    <div
      class="crop-health-map-layout"
      [class.row]="!mapFullscreen"
      [class.col-xl-7]="!isSplitMapLayout && !mapFullscreen"
      [class.col-12]="isSplitMapLayout && !mapFullscreen"
      [class.fullscreen-map-only]="mapFullscreen && !isSplitMapLayout"
      [class.fullscreen-split]="mapFullscreen && isSplitMapLayout">
      @if (mode === 'add' || resolveProblematicSpotMode) {
        <div class="note-panel-col" [class.col-12]="!mapFullscreen" [class.col-xl-5]="!mapFullscreen">
          <div class="box notes-add">
            <app-crop-health-note-form
              [mapInstance]="mapInstance"
              [problematicSpots]="problematicSpots"
              (back)="changeAddNoteMode(false, $event)"
              (addMarker)="addNoteMarker($event)"
              (removeMarker)="removeNoteMarker($event)" />
          </div>
        </div>
      } @else if (mode === 'view') {
        <div class="note-panel-col" [class.col-12]="!mapFullscreen" [class.col-xl-5]="!mapFullscreen">
          <div class="box notes-add">
            <app-crop-health-note-view
              [note]="selectedNoteForView"
              [mapInstance]="mapInstance"
              (back)="changeViewNoteMode(false, $event)"
              (getAllNotes)="getNotes(); cropHealthService.setMode('reset')" />
          </div>
        </div>
      }
      <div
        class="map-panel-col"
        [class.col-12]="!mapFullscreen && !isSplitMapLayout"
        [class.col-xl-7]="!mapFullscreen && isSplitMapLayout">
        <div class="map box" [class.note-mode]="mode == 'view' || mode == 'add'">
          <app-crop-health-map
            [loading]="cropHealthLoading"
            [noteLoading]="noteLoading"
            [cropHealthData]="cropHealthData"
            [selectedMapType]="selectedMapType"
            [noAnalysisIssueState]="noAnalysisIssueState"
            (fullScreenEvent)="fullScreen()"
            (mapReadyEvent)="onMapReady($event)"
            (selectDateEvent)="onSelectDate($event)"
            (loadMoreEvent)="loadMoreCropHealthData()"
            (seeProblematicSpotEvent)="seeProblematicSpot()"
            (viewNoteEvent)="changeViewNoteMode(true, $event, 'map')" />
        </div>
      </div>
    </div>
    @if (mode === 'reset') {
      <div class="col-12 col-xl-5 mt-4 mt-xl-0">
        <div class="notes box">
          <div class="d-flex justify-content-between">
            <p class="title">{{ 'doktar_app.services.crop_monitoring.notes_and_problems' | translate }}</p>

            @if (permissionService.isGrantedOnUserPermissions('Note_Create')) {
              <i class="ph-fill ph-plus-circle plus-icon" (click)="changeAddNoteMode(true)"></i>
            }
          </div>
          <app-crop-health-note-list
            [loading]="noteLoading"
            (addModeChangeEvent)="changeAddNoteMode(true)"
            (seeAllNoteChangeEvent)="cropHealthService.setMode('seeAllNotes')"
            (getAllNotesEvent)="getNotes()"
            (viewNoteEvent)="changeViewNoteMode(true, $event)" />
        </div>
      </div>
      <div class="col-12 col-xl-4 mt-4">
        <div class="distribution box">
          <p class="title">
            @if (selectedMapType?.key === 'ndvi' || selectedMapType?.key === 'risk') {
              <span>{{ 'doktar_app.services.crop_monitoring.ndvi_distribution' | translate }}</span>
            }
            @if (selectedMapType?.key === 'ndmi') {
              <span>{{ 'doktar_app.services.crop_monitoring.ndmi_distribution' | translate }}</span>
            }
            @if (selectedMapType?.key === 'inspection') {
              <span>{{ 'doktar_app.services.crop_monitoring.inspection_distribution' | translate }}</span>
            }
          </p>

          <app-ndvi-ndmi-distribution
            [loading]="cropHealthLoading"
            [data]="ndviNdmiDistributionData"
            [selectedDay]="selectedDay"
            [selectedMapType]="selectedMapType"
            [cropHealthData]="cropHealthData"
            (noAnalysisIssueChanged)="onNoAnalysisIssueChanged($event)" />
        </div>
      </div>
      <div class="col-12 col-xl-8 mt-4">
        @if (selectedMapType?.key !== 'ndmi') {
          <div class="yearly-charts box">
            <p class="title">
              {{ 'doktar_app.services.crop_monitoring.vegetation_health' | translate }}
              <span class="source">{{ 'doktar_app.common.source' | translate }}: Sentinel</span>
            </p>
            <app-vegetation-health
              [loading]="cropHealthAnalysisLoading"
              [data]="ndviAnnualAnalysis"
              [selectedDay]="selectedDay" />
            <p class="title mt-4">
              {{ 'doktar_app.services.crop_monitoring.heat_accumulation' | translate }}
              <span class="source">
                {{ 'doktar_app.common.source' | translate }}: {{ 'doktar_app.common.weather_forecast' | translate }}
              </span>
            </p>
            <app-heat-accumulation
              [loading]="cropHealthAnalysisLoading"
              [data]="gddAnalysisData"
              [selectedDay]="selectedDay" />
          </div>
        } @else {
          <div class="yearly-charts box">
            <p class="title">
              {{ 'doktar_app.services.crop_monitoring.plant_water_stress' | translate }}
              <span class="source">{{ 'doktar_app.common.source' | translate }}: Sentinel</span>
            </p>
            <app-plant-water-stress
              [loading]="cropHealthAnalysisLoading"
              [data]="ndmiAnnualAnalysis"
              [selectedDay]="selectedDay" />
            <p class="title mt-4">
              {{ 'doktar_app.services.crop_monitoring.rainfall_summary' | translate }}
              <span class="source">
                {{ 'doktar_app.common.source' | translate }}: {{ 'doktar_app.common.weather_forecast' | translate }}
              </span>
            </p>
            <app-rainfall-summary
              [loading]="cropHealthAnalysisLoading"
              [data]="precipitationAnalysisData"
              [selectedDay]="selectedDay" />
          </div>
        }
      </div>
    }

    <div class="col-12 mt-4" [class.d-none]="mode !== 'reset'">
      <div class="box">
        <app-phenology />
      </div>
    </div>
  </div>

  <div [class.d-none]="mode !== 'seeAllNotes'" [class.d-block]="mode === 'seeAllNotes'">
    <app-crop-health-note-all
      (back)="cropHealthService.setMode('reset')"
      [loading]="noteLoading"
      (getAllNotes)="getNotes()"
      (viewNote)="changeViewNoteMode(true, $event, 'seeAllNotes')" />
  </div>
</div>
